import { Tablenodatafound } from "../TableNoDataFount";
import {
  MomentHourAndMinuteTime,
  getHrMinFormat,
  getValidData,
} from "../../../Shared/Methods";

interface props {
  Data: any;
  OBJHead: string[];
}

function HistoryReportsTable({ Data, OBJHead }: props) {
  const { items } = Data;

  // const [pageno, setpageno] = useState(0);

  return (
    <>
      <tr>
        {OBJHead?.map((ele) => {
          return <th>{ele}</th>;
        })}
      </tr>
      {items?.length > 0 ? (
        items.map((ele: any, ind: number) => {
          return (
            <>
              <tr>
                {/* <td rowSpan={ele?.data?.length + 1} style={{ width: 50 }}>
                  {pageind * pageSize + (ind + 1)}
                </td> */}
                <td
                  rowSpan={ele?.data?.length + 1}
                  style={{ minWidth: "97px" }}
                >
                  {getValidData(ele?.date)}
                </td>
              </tr>

              {ele?.data?.map((val: any, index: number) => {
                return (
                  <>
                    <tr>
                      <td style={{ width: "100px" }}>{val?.sl_no}</td>
                      <td>{getValidData(val?.typeName)}</td>
                      <td>
                        {getValidData(
                          val?.on_time
                            ? MomentHourAndMinuteTime(val?.on_time)
                            : null
                        )}
                      </td>

                      <td>
                        {getValidData(
                          val?.off_time
                            ? MomentHourAndMinuteTime(val?.off_time)
                            : null
                        )}
                      </td>
                      <td>
                        {getValidData(
                          val?.duration ? getHrMinFormat(val?.duration) : null
                        )}
                      </td>
                    </tr>
                  </>
                );
              })}
            </>
          );
        })
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default HistoryReportsTable;
